/* =========================================================================
   HOMEPALS theme — interactions (loads on every page, guards per element)
   ========================================================================= */
(function(){
'use strict';
var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var INK = '#241712';
var PALETTE = { coral:'#ff6a4d', butter:'#ffc73c', mint:'#3ec7a4', lilac:'#b49cff', sky:'#6fb6ff', leaf:'#7fce5a', bubble:'#ff8fc4' };
var HP = window.HOMEPALS || {};
var ROUTES = HP.routes || { cartAdd:'/cart/add', cart:'/cart', cartChange:'/cart/change' };
var CART_CFG = HP.cart || { type:'drawer', showProgress:true, goal:0, progressMsg:'', successMsg:'' };
var MONEY_FORMAT = (HP.money || '${{amount}}').replace(/<[^>]*>/g,'');

function $(s,r){return (r||document).querySelector(s);}
function $all(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}

/* ---------- on-demand asset loaders (performance) ---------- */
var ASSETS = HP.assets || {};
var _threeLoading=false,_threeCbs=[];
function ensureThree(cb){
  if(window.THREE){ cb(); return; }
  _threeCbs.push(cb);
  if(_threeLoading) return;
  _threeLoading=true;
  if(!ASSETS.three){ return; }
  var s=document.createElement('script'); s.src=ASSETS.three; s.defer=true;
  s.onload=function(){ var q=_threeCbs.splice(0); q.forEach(function(f){ try{f();}catch(e){} }); };
  s.onerror=function(){ _threeLoading=false; };
  document.head.appendChild(s);
}
function ensureModelViewer(cb){
  if(window.customElements && customElements.get('model-viewer')){ cb(); return; }
  if(ASSETS.modelViewer && !document.getElementById('mv-loader')){
    var s=document.createElement('script'); s.id='mv-loader'; s.type='module'; s.src=ASSETS.modelViewer; document.head.appendChild(s);
  }
  if(window.customElements && customElements.whenDefined){ customElements.whenDefined('model-viewer').then(cb); }
  else { setTimeout(cb,1400); }
}

/* ---------- money formatter (Shopify standard) ---------- */
function formatMoney(cents){
  if(typeof cents === 'string'){ cents = cents.replace('.',''); }
  var placeholder=/\{\{\s*(\w+)\s*\}\}/, fmt=MONEY_FORMAT, value='';
  function num(n,p,t,d){ p=(p===undefined)?2:p; t=(t===undefined)?',':t; d=(d===undefined)?'.':d; if(isNaN(n)||n==null)n=0;
    n=(n/100).toFixed(p); var parts=n.split('.'), dollars=parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+t), cc=parts[1]?(d+parts[1]):'';
    return dollars+cc; }
  var token=(fmt.match(placeholder)||[null,'amount'])[1];
  switch(token){
    case 'amount': value=num(cents,2); break;
    case 'amount_no_decimals': value=num(cents,0); break;
    case 'amount_with_comma_separator': value=num(cents,2,'.',','); break;
    case 'amount_with_space_separator': value=num(cents,2,' ','.'); break;
    case 'amount_no_decimals_with_comma_separator': value=num(cents,0,'.',','); break;
    case 'amount_no_decimals_with_space_separator': value=num(cents,0,' '); break;
    default: value=num(cents,2);
  }
  return fmt.replace(placeholder, value);
}

/* ---------- mascot SVG (recolourable, mood-able) ---------- */
function shade(hex,p){var n=parseInt(hex.slice(1),16);var r=(n>>16)&255,g=(n>>8)&255,b=n&255;
  r=Math.max(0,Math.min(255,r+p));g=Math.max(0,Math.min(255,g+p));b=Math.max(0,Math.min(255,b+p));
  return '#'+(1<<24|r<<16|g<<8|b).toString(16).slice(1);}
function pal(color,mood,arm){
  color=color||PALETTE.coral; mood=mood||'happy'; if(arm===undefined)arm=true;
  var eyes={
    happy:'<circle cx="92" cy="120" r="9" fill="'+INK+'"/><circle cx="148" cy="120" r="9" fill="'+INK+'"/><circle cx="95" cy="117" r="3" fill="#fff"/><circle cx="151" cy="117" r="3" fill="#fff"/>',
    wink:'<circle cx="92" cy="120" r="9" fill="'+INK+'"/><circle cx="95" cy="117" r="3" fill="#fff"/><path d="M138 120 q10 -9 20 0" stroke="'+INK+'" stroke-width="6" fill="none" stroke-linecap="round"/>',
    love:'<path d="M92 114 q-8 -10 -16 0 q0 9 16 16 q16 -7 16 -16 q-8 -10 -16 0" fill="#ff3d6e" transform="scale(.55) translate(75 92)"/><path d="M148 114 q-8 -10 -16 0 q0 9 16 16 q16 -7 16 -16 q-8 -10 -16 0" fill="#ff3d6e" transform="scale(.55) translate(112 92)"/>',
    cool:'<rect x="74" y="110" width="92" height="22" rx="11" fill="'+INK+'"/><rect x="80" y="114" width="34" height="14" rx="7" fill="#3ec7a4"/><rect x="126" y="114" width="34" height="14" rx="7" fill="#6fb6ff"/>'
  };
  var mouth={
    happy:'<path d="M98 142 q22 22 44 0" stroke="'+INK+'" stroke-width="6" fill="none" stroke-linecap="round"/>',
    wink:'<path d="M100 144 q20 20 40 2" stroke="'+INK+'" stroke-width="6" fill="none" stroke-linecap="round"/>',
    love:'<path d="M100 142 q20 26 40 0 q-20 8 -40 0" fill="'+INK+'"/>',
    cool:'<path d="M104 146 q16 12 32 0" stroke="'+INK+'" stroke-width="6" fill="none" stroke-linecap="round"/>'
  };
  var dark=shade(color,-22);
  return '<svg viewBox="0 0 240 250" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Pal mascot">'+
    '<ellipse cx="92" cy="232" rx="20" ry="11" fill="'+dark+'" stroke="'+INK+'" stroke-width="5"/>'+
    '<ellipse cx="148" cy="232" rx="20" ry="11" fill="'+dark+'" stroke="'+INK+'" stroke-width="5"/>'+
    '<path d="M196 150 q22 -6 30 -28" stroke="'+INK+'" stroke-width="11" fill="none" stroke-linecap="round"/>'+
    '<circle cx="226" cy="120" r="10" fill="'+color+'" stroke="'+INK+'" stroke-width="5"/>'+
    '<rect x="56" y="92" width="128" height="130" rx="26" fill="'+color+'" stroke="'+INK+'" stroke-width="6"/>'+
    '<path d="M50 96 L120 36 L190 96 Z" fill="'+dark+'" stroke="'+INK+'" stroke-width="6" stroke-linejoin="round"/>'+
    '<rect x="150" y="52" width="16" height="26" rx="4" fill="'+dark+'" stroke="'+INK+'" stroke-width="5"/>'+
    '<circle cx="74" cy="138" r="10" fill="#ff5277" opacity=".55"/><circle cx="166" cy="138" r="10" fill="#ff5277" opacity=".55"/>'+
    '<g class="blink" style="transform-origin:120px 120px">'+(eyes[mood]||eyes.happy)+'</g>'+(mouth[mood]||mouth.happy)+
    '<rect x="104" y="178" width="32" height="40" rx="8" fill="'+dark+'" stroke="'+INK+'" stroke-width="5"/>'+
    '<circle cx="128" cy="198" r="3" fill="'+color+'"/>'+
    (arm?'<g class="palarm"><path d="M44 150 q-22 -6 -30 -28" stroke="'+INK+'" stroke-width="11" fill="none" stroke-linecap="round"/><circle cx="14" cy="120" r="10" fill="'+color+'" stroke="'+INK+'" stroke-width="5"/></g>':'')+
    '</svg>';
}
function setPal(id,color,mood,arm){var el=document.getElementById(id); if(el) el.innerHTML=pal(color,mood,arm);}

setPal('navlogo',PALETTE.coral,'happy',false);
setPal('heropal',PALETTE.coral,'happy',true);
setPal('bigpal',PALETTE.coral,'happy',true);
setPal('ppal',PALETTE.coral,'happy',false);
setPal('footpal',PALETTE.butter,'happy',true);
setPal('arfallpal',PALETTE.sky,'cool',false);
setPal('notfoundpal',PALETTE.coral,'happy',true);
setPal('passpal',PALETTE.butter,'happy',true);
setPal('cdEmptyPal',PALETTE.coral,'love',true);
$all('.float').forEach(function(el){ el.innerHTML=pal(PALETTE[el.dataset.pal]||PALETTE.coral,'happy',false); });

/* moods */
var moods=$('#moods');
if(moods){ moods.addEventListener('click',function(e){
  var b=e.target.closest('.mood'); if(!b)return;
  $all('.mood',moods).forEach(function(m){m.setAttribute('aria-pressed','false');});
  b.setAttribute('aria-pressed','true'); setPal('bigpal',PALETTE.coral,b.dataset.mood,true);
});}

/* marquee */
var mtrack=$('#mtrack');
if(mtrack){
  var words=(mtrack.dataset.words||'FORGOTTEN NO MORE,PALS FOR EVERY CORNER,SPIN IT · PLACE IT · ADOPT IT').split(',');
  var html=''; for(var k=0;k<2;k++){ html+=words.map(function(w){return '<span>'+w.trim()+' <b>✦</b></span>';}).join(''); }
  mtrack.innerHTML=html;
}

/* =========================================================================
   STATIC section backgrounds (replaces the old scroll gradient morph)
   ========================================================================= */
$all('[data-bg]').forEach(function(el){
  var c = el.getAttribute('data-bg');
  if(c && el.tagName.toLowerCase() !== 'footer'){ el.style.backgroundColor = c; }
});

/* =========================================================================
   THREE.JS — hero floaters  (called only after Three.js is loaded on demand)
   ========================================================================= */
function heroScene(){
  var host=$('#scene'); if(!host||!window.THREE)return;
  var renderer=new THREE.WebGLRenderer({alpha:true,antialias:true});
  renderer.setPixelRatio(Math.min(window.devicePixelRatio,2)); host.appendChild(renderer.domElement);
  var scene=new THREE.Scene();
  var cam=new THREE.PerspectiveCamera(45,1,.1,100); cam.position.set(0,0,16);
  scene.add(new THREE.AmbientLight(0xffffff,.85));
  var dl=new THREE.DirectionalLight(0xffffff,.9); dl.position.set(5,8,10); scene.add(dl);
  var dl2=new THREE.DirectionalLight(0xffd0b0,.5); dl2.position.set(-8,-4,4); scene.add(dl2);
  var cols=[PALETTE.butter,PALETTE.mint,PALETTE.lilac,PALETTE.sky,PALETTE.coral,PALETTE.leaf,PALETTE.bubble];
  var geos=[new THREE.SphereGeometry(1,24,24),new THREE.BoxGeometry(1.6,1.6,1.6,4,4,4),new THREE.TorusGeometry(1,.42,16,32),new THREE.CylinderGeometry(.9,.9,1.6,24),new THREE.IcosahedronGeometry(1.1,0),new THREE.ConeGeometry(1.1,1.8,24)];
  var shapes=[];
  for(var i=0;i<11;i++){
    var g=geos[i%geos.length].clone();
    var m=new THREE.MeshStandardMaterial({color:new THREE.Color(cols[i%cols.length]),roughness:.55,metalness:.05});
    var mesh=new THREE.Mesh(g,m); var ang=(i/11)*Math.PI*2;
    mesh.position.set(Math.cos(ang)*7.5+(Math.random()-.5)*2,(Math.random()-.5)*9,-2-Math.random()*7);
    mesh.scale.setScalar(.7+Math.random()*.8);
    mesh.userData={sp:.2+Math.random()*.5,off:Math.random()*6.28,base:mesh.position.y,amp:.4+Math.random()*.5};
    scene.add(mesh); shapes.push(mesh);
  }
  function size(){var r=host.getBoundingClientRect();renderer.setSize(r.width,r.height);cam.aspect=r.width/Math.max(1,r.height);cam.updateProjectionMatrix();}
  size(); window.addEventListener('resize',size);
  var sY=0; window.addEventListener('scroll',function(){sY=window.scrollY;},{passive:true});
  var clock=new THREE.Clock();
  (function loop(){requestAnimationFrame(loop);var t=clock.getElapsedTime();
    shapes.forEach(function(s){ if(!REDUCED){s.rotation.x+=.003*s.userData.sp;s.rotation.y+=.005*s.userData.sp;s.position.y=s.userData.base+Math.sin(t*s.userData.sp+s.userData.off)*s.userData.amp;} });
    cam.position.y=-sY*0.004; cam.position.x=Math.sin(t*.1)*.6; cam.lookAt(0,cam.position.y*.4,0);
    renderer.render(scene,cam);
  })();
}

/* =========================================================================
   THREE.JS — 3D carousel of product photos (#showcase-data)
   (called only after Three.js is loaded on demand)
   ========================================================================= */
function showcaseScene(){
  var cv=$('#showcanvas'), dataEl=$('#showcase-data'); if(!cv||!dataEl||!window.THREE)return;
  var items=[]; try{ items=JSON.parse(dataEl.textContent.trim()||'[]'); }catch(e){ items=[]; }
  items=items.filter(function(it){return it && it.img;});
  if(!items.length){ cv.style.display='none'; return; }
  var renderer=new THREE.WebGLRenderer({canvas:cv,alpha:true,antialias:true});
  renderer.setPixelRatio(Math.min(window.devicePixelRatio,2));
  if('outputEncoding' in renderer) renderer.outputEncoding=THREE.sRGBEncoding;
  var scene=new THREE.Scene();
  var cam=new THREE.PerspectiveCamera(40,1,.1,100); cam.position.set(0,0,9);
  var loader=new THREE.TextureLoader();
  var N=items.length, R=Math.max(5.4, N*0.46), frames=[];
  items.forEach(function(it,i){
    var tex=loader.load(it.img); if('encoding' in tex) tex.encoding=THREE.sRGBEncoding;
    var grp=new THREE.Group();
    var back=new THREE.Mesh(new THREE.PlaneGeometry(2.18,2.18),new THREE.MeshBasicMaterial({color:new THREE.Color(INK)})); back.position.z=-0.01;
    var photo=new THREE.Mesh(new THREE.PlaneGeometry(2,2),new THREE.MeshBasicMaterial({map:tex}));
    var tab=new THREE.Mesh(new THREE.PlaneGeometry(2.18,.34),new THREE.MeshBasicMaterial({color:new THREE.Color(PALETTE[it.color]||PALETTE.coral)})); tab.position.set(0,-1.26,0);
    grp.add(back,photo,tab); grp.userData={base:(i/N)*Math.PI*2,url:it.url}; scene.add(grp); frames.push(grp);
  });
  function size(){var r=cv.getBoundingClientRect();renderer.setSize(r.width,r.height,false);cam.aspect=r.width/Math.max(1,r.height);cam.updateProjectionMatrix();}
  size(); window.addEventListener('resize',size);
  var drag=false,px=0,moved=0,vel=.0035,manual=0;
  cv.style.cursor='grab';
  cv.addEventListener('pointerdown',function(e){drag=true;moved=0;px=e.clientX;cv.setPointerCapture(e.pointerId);});
  cv.addEventListener('pointermove',function(e){if(drag){var d=(e.clientX-px);manual+=d*.006;moved+=Math.abs(d);px=e.clientX;}});
  cv.addEventListener('pointerup',function(){drag=false;});
  var clock=new THREE.Clock();
  (function loop(){requestAnimationFrame(loop);var t=clock.getElapsedTime();
    if(!REDUCED&&!drag) manual+=vel;
    frames.forEach(function(g){var a=g.userData.base+manual;
      g.position.set(Math.sin(a)*R, REDUCED?0:Math.sin(t*1.1+g.userData.base)*.18, Math.cos(a)*R - R);
      var s=0.62+0.5*((Math.cos(a)+1)/2); g.scale.setScalar(s); g.quaternion.copy(cam.quaternion);
    });
    frames.slice().sort(function(a,b){return a.position.z-b.position.z;}).forEach(function(g,idx){g.renderOrder=idx;});
    renderer.render(scene,cam);
  })();
}

/* Load Three.js only if this page actually has 3D content, then start the scenes */
if($('#scene') || $('#showcanvas')){
  ensureThree(function(){ heroScene(); showcaseScene(); });
}

/* =========================================================================
   SCROLL — nav solidify, progress rail, reveals  (NO background morph)
   ========================================================================= */
var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)e.target.classList.add('in');});},{threshold:.16}) : null;
if(io){ $all('.reveal').forEach(function(el){io.observe(el);}); }
else { $all('.reveal').forEach(function(el){el.classList.add('in');}); }
window.addEventListener('load',function(){ setTimeout(function(){ $all('.reveal:not(.in)').forEach(function(el){ var r=el.getBoundingClientRect(); if(r.top < window.innerHeight*1.2) el.classList.add('in'); }); }, 600); });

var room=$('#room');
if(room){ var rio = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)room.classList.add('lit');});},{threshold:.25}) : null;
  if(rio){ rio.observe(room); } else { room.classList.add('lit'); } }

var nav=$('#nav'), pfill=$('#pfill'), ppal=$('#ppal');
function onScroll(){
  var y=window.scrollY,h=window.innerHeight;
  if(nav) nav.classList.toggle('solid', y>40);
  var max=document.body.scrollHeight-h, prog=max>0?Math.min(1,Math.max(0,y/max)):0;
  if(pfill) pfill.style.height=(prog*100)+'%';
  if(ppal) ppal.style.bottom=(prog*100)+'%';
}
window.addEventListener('scroll',onScroll,{passive:true});
window.addEventListener('resize',onScroll); onScroll();

/* =========================================================================
   HEADER — mobile menu toggle + dropdowns + announcement dismiss
   ========================================================================= */
var navToggle=$('#navToggle'), navlinks=$('#navlinks');
function closeMenu(){
  if(!navlinks) return;
  navlinks.classList.remove('open');
  if(navToggle){ navToggle.classList.remove('is-open'); navToggle.setAttribute('aria-expanded','false'); }
}
if(navToggle && navlinks){
  navToggle.addEventListener('click',function(){
    var open=navlinks.classList.toggle('open');
    navToggle.setAttribute('aria-expanded',open?'true':'false');
    navToggle.classList.toggle('is-open',open);
  });
  /* tapping a real menu link closes the mobile menu (dropdown parent toggles don't) */
  navlinks.addEventListener('click',function(e){
    var a=e.target.closest('a'); if(!a) return;
    if(a.parentNode && a.parentNode.classList.contains('nav-has-drop')) return; /* parent toggle */
    if(window.matchMedia('(max-width:760px)').matches){ closeMenu(); }
  });
}
$all('.nav-has-drop > a').forEach(function(a){
  a.addEventListener('click',function(e){
    if(window.matchMedia('(max-width:760px)').matches){ e.preventDefault(); a.parentNode.classList.toggle('open'); }
  });
});
var annX=$('#announcementX'), annBar=$('#announcementBar');
function setAnnH(){ if(annBar && annBar.style.display!=='none'){ document.documentElement.style.setProperty('--ann-h', annBar.offsetHeight+'px'); } else { document.documentElement.style.setProperty('--ann-h','0px'); } }
if(annBar){
  try{ if(sessionStorage.getItem('hp_ann_dismissed')==='1') annBar.style.display='none'; }catch(e){}
  setAnnH(); window.addEventListener('resize',setAnnH); window.addEventListener('load',setAnnH);
  if(annX){ annX.addEventListener('click',function(){ annBar.style.display='none'; setAnnH(); try{sessionStorage.setItem('hp_ann_dismissed','1');}catch(e){} }); }
}

/* =========================================================================
   ROOM FILTERS (#filters + #grid)
   ========================================================================= */
var filters=$('#filters'), grid=$('#grid'), noresult=$('#noresult');
if(filters && grid){
  var counts={all:0,kitchen:0,bath:0,living:0,entryway:0};
  $all('.card',grid).forEach(function(c){counts.all++; var r=c.dataset.room; if(counts[r]!==undefined)counts[r]++;});
  $all('.chip',filters).forEach(function(chip){var s=chip.querySelector('span'); if(s)s.textContent=counts[chip.dataset.room]!==undefined?counts[chip.dataset.room]:'';});
  filters.addEventListener('click',function(e){
    var chip=e.target.closest('.chip'); if(!chip)return;
    $all('.chip',filters).forEach(function(c){c.setAttribute('aria-pressed','false');});
    chip.setAttribute('aria-pressed','true');
    var rm=chip.dataset.room, shown=0;
    $all('.card',grid).forEach(function(card){var ok=rm==='all'||card.dataset.room===rm; card.classList.toggle('hidden',!ok); if(ok)shown++;});
    if(noresult) noresult.hidden=shown>0;
  });
}

/* =========================================================================
   CART — drawer + AJAX adopt
   ========================================================================= */
function toast(msg){var t=$('#toast'),tt=$('#toasttext'); if(!t)return; if(tt)tt.textContent=msg; t.classList.add('show'); clearTimeout(toast._t); toast._t=setTimeout(function(){t.classList.remove('show');},1900);}
function bumpCart(n){ $all('#cartcount').forEach(function(el){el.textContent=n;}); var cb=$('#cartbtn'); if(cb){cb.classList.add('pop');setTimeout(function(){cb.classList.remove('pop');},250);} }
function announce(msg){ var l=$('#cdLive'); if(l){ l.textContent=''; setTimeout(function(){ l.textContent=msg; }, 30); } }

var drawer=$('#cartDrawer'), overlay=$('#cdOverlay'), lastFocused=null, cartBusy=false;
function lockScroll(on){ document.documentElement.style.overflow = on?'hidden':''; }
function cdFocusables(){ if(!drawer) return []; return Array.prototype.filter.call(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'), function(el){ return el.offsetParent !== null; }); }
function onTrapKey(e){
  if(e.key==='Escape'){ closeDrawer(); return; }
  if(e.key!=='Tab') return;
  var f=cdFocusables(); if(!f.length) return;
  var first=f[0], last=f[f.length-1];
  if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
  else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
}
function openDrawer(){ if(!drawer)return; if(drawer.classList.contains('open')) return;
  lastFocused=document.activeElement;
  drawer.hidden=false; overlay.hidden=false;
  requestAnimationFrame(function(){ drawer.classList.add('open'); overlay.classList.add('show'); });
  drawer.setAttribute('aria-hidden','false'); lockScroll(true);
  document.addEventListener('keydown', onTrapKey);
  setTimeout(function(){ var c=$('#cdClose'); if(c){ try{ c.focus(); }catch(e){} } }, 80);
}
function closeDrawer(){ if(!drawer)return; drawer.classList.remove('open'); overlay.classList.remove('show');
  drawer.setAttribute('aria-hidden','true'); lockScroll(false);
  document.removeEventListener('keydown', onTrapKey);
  setTimeout(function(){ if(!drawer.classList.contains('open')){ drawer.hidden=true; overlay.hidden=true; } },300);
  if(lastFocused && lastFocused.focus){ try{ lastFocused.focus(); }catch(e){} }
}

function renderCart(cart){
  bumpCart(cart.item_count);
  var cdCount=$('#cdCount'); if(cdCount) cdCount.textContent=cart.item_count;
  var sub=$('#cdSubtotal'); if(sub) sub.textContent=formatMoney(cart.total_price);
  var scroll=$('#cdScroll'), body=$('#cdBody'), empty=$('#cdEmpty'), foot=$('#cdFoot');

  if(cart.item_count===0){
    if(body) body.innerHTML='';
    if(scroll) scroll.hidden=true;
    if(empty) empty.hidden=false;
    if(foot) foot.hidden=true;
  } else {
    if(empty) empty.hidden=true;
    if(scroll) scroll.hidden=false;
    if(foot) foot.hidden=false;
    if(body){
      body.innerHTML = cart.items.map(function(it){
        var variant = (it.variant_title && it.variant_title.indexOf('Default')<0) ? '<div class="cd-item-var">'+it.variant_title+'</div>' : '';
        var img = it.image ? '<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2')+'" alt="" width="84" height="84">' : '<div class="cd-item-noimg">🧡</div>';
        var sale = it.original_line_price > it.final_line_price;
        var price = '<span class="cd-item-price">'+formatMoney(it.final_line_price)+(sale?' <s>'+formatMoney(it.original_line_price)+'</s>':'')+'</span>';
        return '<div class="cd-item" data-key="'+it.key+'">'+
          '<a class="cd-item-media" href="'+it.url+'">'+img+'</a>'+
          '<div class="cd-item-info">'+
            '<div class="cd-item-top">'+
              '<a class="cd-item-title" href="'+it.url+'">'+it.product_title+'</a>'+
              '<button class="cd-remove" data-act="remove" aria-label="Remove '+(it.product_title||'item').replace(/"/g,'')+'"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>'+
            '</div>'+
            variant+
            '<div class="cd-item-bottom">'+
              '<div class="cd-qty">'+
                '<button class="cd-qty-btn" data-act="dec" aria-label="Decrease quantity">−</button>'+
                '<span class="cd-qty-n" aria-live="polite">'+it.quantity+'</span>'+
                '<button class="cd-qty-btn" data-act="inc" aria-label="Increase quantity">+</button>'+
              '</div>'+
              price+
            '</div>'+
          '</div>'+
        '</div>';
      }).join('');
    }
    loadCrossSell(cart);
  }

  /* free-ship progress */
  var prog=$('#cdProgress');
  if(prog && CART_CFG.showProgress && CART_CFG.goal>0){
    var total=cart.total_price, goal=CART_CFG.goal, pct=Math.min(100, Math.round(total/goal*100));
    var fill=$('#cdProgressFill'), msg=$('#cdProgressMsg'), unlocked=total>=goal;
    if(fill) fill.style.width=pct+'%';
    prog.classList.toggle('is-unlocked', unlocked);
    if(msg){
      if(unlocked){ msg.innerHTML='<span class="cd-prog-check">✓</span> '+(CART_CFG.successMsg||''); }
      else { var remaining=formatMoney(goal-total); msg.innerHTML=(CART_CFG.progressMsg||'').replace('[remaining]','<strong>'+remaining+'</strong>'); }
    }
    var nowEl=$('#cdProgressNow'), goalEl=$('#cdProgressGoal');
    if(nowEl) nowEl.textContent=formatMoney(total)+' · '+pct+'%';
    if(goalEl) goalEl.textContent=unlocked ? 'Free delivery ✓' : 'Goal '+formatMoney(goal);
    prog.hidden = cart.item_count===0;
  } else if(prog){ prog.hidden=true; }
}

/* cross-sell rail (recommendations for the first cart item) */
var recCache={};
function loadCrossSell(cart){
  var rail=$('#cdCross'); if(!rail || !CART_CFG.crossSell) return;
  if(!cart.items || !cart.items.length){ rail.hidden=true; rail.innerHTML=''; return; }
  var pid=cart.items[0].product_id;
  var inCart={}; cart.items.forEach(function(it){ inCart[it.product_id]=true; });
  function render(products){
    products=(products||[]).filter(function(p){ return !inCart[p.id] && p.available !== false; }).slice(0,8);
    if(!products.length){ rail.hidden=true; rail.innerHTML=''; return; }
    rail.innerHTML='<div class="cd-xc-head"><span class="kicker">'+(CART_CFG.crossHeading||'Adopt the whole squad')+'</span></div>'+
      '<div class="cd-xc-track">'+products.map(function(p){
        var v=null, vs=p.variants||[];
        for(var i=0;i<vs.length;i++){ if(vs[i].available){ v=vs[i]; break; } }
        if(!v && vs.length) v=vs[0];
        var raw=p.featured_image||p.image||(p.images&&p.images[0])||'';
        var img= raw ? '<img src="'+String(raw).replace(/(\.[a-z]+)(\?|$)/i,'_240x$1$2')+'" alt="" loading="lazy">' : '<span aria-hidden="true">🧡</span>';
        var addBtn = (v && v.id) ? '<button class="adopt sm cd-xc-add" data-variant="'+v.id+'" data-title="'+String(p.title||'').replace(/"/g,'&quot;')+'">+ Add</button>' : '';
        return '<article class="cd-xc">'+
          '<a class="cd-xc-link" href="'+p.url+'"><span class="cd-xc-thumb">'+img+'</span>'+
          '<span class="cd-xc-title">'+p.title+'</span>'+
          '<span class="cd-xc-price">'+formatMoney(p.price)+'</span></a>'+addBtn+'</article>';
      }).join('')+'</div>';
    rail.hidden=false;
  }
  if(recCache[pid]){ render(recCache[pid]); return; }
  var base=(ROUTES.recommendations||'/recommendations/products');
  fetch(base+'.js?product_id='+pid+'&limit=8&intent=related',{headers:{'Accept':'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(d){ recCache[pid]=d.products||[]; render(recCache[pid]); })
    .catch(function(){ rail.hidden=true; });
}

function fetchCart(){ return fetch(ROUTES.cart+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }

function adopt(variantId,title,btn){
  if(!variantId)return;
  if(btn)btn.disabled=true;
  fetch(ROUTES.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})})
    .then(function(r){ return r.json().then(function(data){ return { ok:r.ok, data:data }; }); })
    .then(function(res){ if(!res.ok){ throw new Error((res.data && res.data.description) || 'add'); } return fetchCart(); })
    .then(function(cart){
      renderCart(cart);
      var msg=(CART_CFG.addedMsg||'[product] has been adopted!').replace('[product]', title||'Pal');
      if(CART_CFG.type==='page'){ window.location.href=ROUTES.cart; return; }
      if(CART_CFG.showToast!==false){ toast(msg); }
      announce(msg);
      if(CART_CFG.type==='drawer'){ openDrawer(); }
    })
    .catch(function(err){ toast(err && err.message && err.message!=='add' ? err.message : 'Could not add — please try again'); })
    .then(function(){ if(btn)btn.disabled=false; });
}

function changeLine(key,qty,itemEl){
  cartBusy=true;
  if(itemEl) itemEl.classList.add('is-busy');
  fetch(ROUTES.cartChange,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
    .then(function(r){return r.json();})
    .then(function(cart){ renderCart(cart); announce('Cart updated'); })
    .catch(function(){ toast('Could not update cart'); return fetchCart().then(renderCart); })
    .then(function(){ cartBusy=false; });
}

document.addEventListener('click',function(e){
  var b=e.target.closest('.adopt[data-variant]'); if(!b)return;
  e.preventDefault(); e.stopPropagation();
  adopt(b.getAttribute('data-variant'), b.getAttribute('data-title'), b);
});

if(drawer){
  $('#cdClose') && $('#cdClose').addEventListener('click',closeDrawer);
  overlay && overlay.addEventListener('click',closeDrawer);
  $all('.cd-close-link').forEach(function(a){ a.addEventListener('click',closeDrawer); });
  drawer.addEventListener('click',function(e){
    var qb=e.target.closest('.cd-qty-btn, .cd-remove'); if(!qb)return;
    if(cartBusy) return;
    var item=qb.closest('.cd-item'); if(!item)return;
    var key=item.getAttribute('data-key');
    var nEl=item.querySelector('.cd-qty-n');
    var n=parseInt(nEl?nEl.textContent:'1',10)||1;
    var act=qb.getAttribute('data-act');
    var newN = act==='inc' ? n+1 : act==='dec' ? Math.max(0,n-1) : 0;
    if(act!=='remove' && nEl) nEl.textContent=newN; /* optimistic */
    changeLine(key,newN,item);
  });
  var cartbtn=$('#cartbtn');
  if(cartbtn && CART_CFG.type==='drawer'){
    cartbtn.addEventListener('click',function(e){ e.preventDefault(); fetchCart().then(function(cart){ renderCart(cart); openDrawer(); }); });
  }
  fetchCart().then(renderCart).catch(function(){});
}

/* =========================================================================
   PRODUCT PAGE — variants, gallery, 3D / AR, AJAX adopt
   ========================================================================= */
(function pdp(){
  var viewer=$('#pdpViewer'); if(!viewer)return;
  var hidden=$('#pdpVariantId'), variants=$('#variants');
  if(variants){ variants.addEventListener('change',function(e){ var r=e.target.closest('input[name="variantpick"]'); if(r&&hidden) hidden.value=r.value; }); }
  $all('.pdp-thumb').forEach(function(btn){ btn.addEventListener('click',function(){ var photo=$('#pdpPhoto'); if(photo) photo.src=btn.getAttribute('data-full'); }); });

  var form=$('#pdpForm');
  if(form && CART_CFG.type!=='page'){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var id=(hidden && hidden.value) || (form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value);
      var titleEl=document.querySelector('.pdp-info h1'); var title=titleEl?titleEl.textContent:'';
      var addBtn=form.querySelector('[name="add"]');
      adopt(id, title, addBtn);
    });
  }

  function goAR(){
    var glb=viewer.getAttribute('data-glb'); if(!glb)return;
    var usdz=viewer.getAttribute('data-usdz'), poster=viewer.getAttribute('data-poster');
    toast('Loading 3D…');
    ensureModelViewer(function(){
      viewer.innerHTML='';
      var mv=document.createElement('model-viewer');
      mv.setAttribute('src',glb);
      if(usdz) mv.setAttribute('ios-src',usdz);
      if(poster) mv.setAttribute('poster',poster);
      mv.setAttribute('camera-controls',''); mv.setAttribute('auto-rotate','');
      mv.setAttribute('shadow-intensity','1'); mv.setAttribute('exposure','1.05');
      mv.setAttribute('ar',''); mv.setAttribute('ar-modes','webxr scene-viewer quick-look'); mv.setAttribute('ar-scale','auto');
      mv.setAttribute('loading','eager'); mv.setAttribute('reveal','auto');
      mv.style.width='100%'; mv.style.height='100%';
      viewer.appendChild(mv);
      toast('On a phone, tap the AR icon to place it 📱');
    });
  }
  var arBtn=$('#pdpAR'); if(arBtn) arBtn.addEventListener('click',goAR);
  var photo=$('#pdpPhoto'); if(photo && viewer.getAttribute('data-glb')){ photo.addEventListener('click',goAR); }
})();

/* newsletter success toast */
if($('#nl-ok')) toast("You're on the list! 🧡");

})();
